import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { doGetSession, getActiveSession } from '../../utilities'
function AdminSidebar({ router, user_type, user_session }) {
    // const router = useRouter()
    const [user, setUser] = useState(null)
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [homeUrl, setHomeUrl] = useState('/')
    const [userType, setUserType] = useState('admin')
    const [loading, setLoading] = useState(false)
    const [activeScope, setActiveScope] = React.useState(null)
    const [activeScopeCode, setActiveScopeCode] = React.useState(null)

    const getScopConf = (id, isItInit) => {
        if (id) getActiveSession(id)
            .then((activeP) => {
                if (activeP) {
                    setActiveScope(activeP)
                    if (!isItInit) {
                        router.reload()
                        // if (router.pathname !== '/user') {
                        //     router.push('/user/surveys')
                        // }
                    }
                }
            })
    }

    useEffect(() => {
        let mtd = true;
        if (mtd) {
            setLoading(true)
            // doGetSession().then(session => {
                if (user_session) {
                    // console.log('user_session', user_session)
                    setUser(user_session.user)
                    setIsLoggedIn(true)
                    // setHomeUrl(user_session.user.type === 'admin' ? '/admin' : '/user')
                    //////
                    let u_t = user_session.user.type;
                    if (u_t) {
                        if (u_t && u_t.toLocaleLowerCase().includes('scope') || userType.toLocaleLowerCase().trim().split(' ').join('_') == 'scope_manager') {
                            setUserType('scope_manager')
                            if(user_session?.user?.scopes && user_session?.user?.scopes?.length > 0){
                                let scp = user_session?.user?.scopes[0]
                                if(scp?.uuid){
                                    setActiveScope(scp)
                                    setActiveScopeCode(scp?.uuid)
                                    setHomeUrl(`/admin/scopes/${scp?.uuid}`)
                                    // getScopConf(scp?.uuid, true)
                                }
                            }
                        } else if (u_t.includes(' admin')) {
                            setUserType('admin')
                            // setHomeUrl('/user')
                        } else {
                            setHomeUrl('/')
                        }
                    }
                    if (user_session?.activeScopeCode && (userType.toLocaleLowerCase().includes('scope') || userType.toLocaleLowerCase() == 'scope_manager')) {
                        getScopConf(user_session?.activeScopeCode, true)
                    } else {
                        if (
                            router.pathname !== '/user' &&
                            router.pathname !== '/user/settings/account'
                        ) {
                            // router.push('/user', undefined, { unstable_skipClientCache: true })
                        }
                    }
                    //////
                }
                setLoading(false)
            // })

            if(typeof window !== 'undefined') {
                const sidebarMenu = document.getElementById('sidebarMenu')
                // if site is staging/development, replace class(bg-violet-dark) with bg-amber-700
                if (sidebarMenu && (window.location.hostname.includes('-pilot') || window.location.hostname.includes('localhost'))) {
                    sidebarMenu.classList.remove('bg-violet-darkest')
                    sidebarMenu.classList.add('bg-stone-800')
                }
            }
        }
        return () => {
            mtd = false;
        }
    }, [])
    return (
        <nav id="sidebarMenu" className="col-xs-12 col-md-2 col-lg-2 col-xl-2 d-md-block bg-violet-darkest text-light sidebar collapse" style={{ top: '1rem' }}>
            <div className="position-sticky pt-0 w-100 overflow-hidden mt-3">
                <ul className="list-unstyled ps-0">
                    <li className="mb-1 d-md-none d-flex align-items-start justify-content-end w-100 p-0">
                        <button className="navbar-toggler d-md-none collapsed text-right s3 p-0" style={{ marginRight: '2.1em' }} type="button" data-bs-toggle="collapse" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
                            &times;
                        </button>
                    </li>
                    {loading ? <>
                        <li className="mb-1">
                            {Array(5).fill().map((_, i) => (
                                <div key={i} className="shimmer rounded w-100 my-3" style={{ height: '30px' }}></div>
                            ))}
                        </li>
                    </> : (
                        userType == 'scope_manager' && activeScopeCode ?
                        <>
                            {/* <li className="mb-1"><hr className='border-slate-400' /></li>
                            <li className="mb-1"><h6 className='mb-0'>{activeScope?.name}</h6></li>
                            <li className="mb-1"><hr className='border-slate-400' /></li> */}
                            <li className="mb-1">
                                <Link href={`/admin/scopes/${activeScopeCode}`} className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (router.asPath === `/admin/scopes/${activeScopeCode}` ? 'active' : '')}>

                                    <i className='fa fa-dashboard text-indigo-300' />Overview
                                                                        
                                </Link>
                            </li>
                            <li className="mb-1">
                                <Link href={`/admin/scopes/${activeScopeCode}/configs`} className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (router.asPath.includes(`/admin/scopes/${activeScopeCode}/configs`) ? 'active' : '')}>

                                    <i className='fa fa-cogs text-indigo-300' />Settings/Configurations
                                                                        
                                </Link>
                            </li>
                            <li className="mb-1">
                                <Link href={`/admin/scopes/${activeScopeCode}/participants`} className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (router.asPath.includes(`/admin/scopes/${activeScopeCode}/participants`) ? 'active' : '')}>

                                    <i className='fa fa-users text-indigo-300' />Enrolled Participants
                                                                        
                                </Link>
                            </li>
                            <li className="mb-1">
                                <Link href={`/admin/scopes/${activeScopeCode}/panels`} className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (router.asPath.includes(`/admin/scopes/${activeScopeCode}/panels`) ? 'active' : '')}>

                                    <i className='fa fa-folder text-indigo-300' />Panels
                                                                        
                                </Link>
                            </li>
                            <li className="mb-1">
                                <Link href={`/admin/scopes/${activeScopeCode}/rounds`} className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (router.asPath.includes(`/admin/scopes/${activeScopeCode}/cycles`) ? 'active' : '')}>

                                    <i className='fa fa-calendar-alt text-indigo-300' />Cycles
                                                                        
                                </Link>
                            </li>
                            <li className="mb-1">
                                <Link href={`/admin/scopes/${activeScopeCode}/reports`} className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (router.asPath.includes(`/admin/scopes/${activeScopeCode}/reports`) ? 'active' : '')}>

                                    <i className='fa fa-file-text text-indigo-300' />Report templates
                                                                        
                                </Link>
                            </li>
                            <li className="mb-1">
                                <Link href={`/admin/scopes/${activeScopeCode}/forms`} className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (router.asPath.includes(`/admin/scopes/${activeScopeCode}/forms`) ? 'active' : '')}>

                                    <i className='fa fa-clipboard text-indigo-300' />Surveys
                                                                        
                                </Link>
                            </li>
                            <li className="mb-1"><hr className='border-slate-400' /></li>
                            <li className="mb-1">
                                <Link href={`/admin/users`} className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (router.asPath.includes('/admin/users') ? 'active' : '')}>

                                    <i className='fa fa-users text-indigo-300' />All users
                                                                        
                                </Link>
                            </li>
                            <li className="mb-1">
                                <Link href={`/admin/orgunits`} className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (router.asPath.includes('/admin/orgunits') ? 'active' : '')}>

                                    <i className='fa fa-map text-indigo-300' />All Organization Units
                                                                        
                                </Link>
                            </li>
                        </> : 
                        <>
                            <li className="mb-1">
                                <Link href="/admin" className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (router.asPath === '/admin' ? 'active' : '')}>

                                    <i className='fa fa-dashboard text-indigo-300' />Overview
                                                                        
                                </Link>
                            </li>
                            <li className="mb-1">
                                <button className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (
                                    router.asPath.includes('/admin/users') ? 'active' : 'collapsed'
                                )} data-bs-toggle="collapse" data-bs-target="#menu_users" aria-expanded={
                                    router.asPath.includes('/admin/users') ? 'true' : 'false'
                                }>
                                    <i className='fa fa-users text-indigo-300' />
                                    Users
                                </button>
                                <div className={"collapse " + (
                                    router.asPath.includes('/admin/users') ? 'show' : ''
                                )} id="menu_users">
                                    <ul className="btn-toggle-nav list-unstyled fw-normal pb-2 small">
                                        <li> <Link href="/admin/users" className={"dropdown-item py-1 " + (router.pathname == '/admin/users' ? ' active' : '')}>All users</Link> </li>
                                        <li> <Link href="/admin/users/groups" className={"dropdown-item py-1 " + (router.pathname == '/admin/users/groups' ? ' active' : '')}>User groups</Link> </li>
                                        <li> <Link href="/admin/users/new" className={"dropdown-item py-1 " + (router.pathname == '/admin/users/new' ? ' active' : '')}>Add new user</Link> </li>
                                    </ul>
                                </div>
                            </li>
                            <li className="mb-1">
                                <button className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (
                                    router.pathname.includes('/admin/scopes') ? 'active' : 'collapsed'
                                )} data-bs-toggle="collapse" data-bs-target="#menu_pt_scopes" aria-expanded={
                                    router.pathname.includes('/admin/scopes') ? 'true' : 'false'
                                }>
                                    <i className='fa fa-folder text-indigo-300' />
                                    Scopes
                                </button>
                                <div className={"collapse " + (
                                    router.pathname.includes('/admin/scopes') ? 'show' : ''
                                )} id="menu_pt_scopes">
                                    <ul className="btn-toggle-nav list-unstyled fw-normal pb-2 small">
                                        <li> <Link
                                            href="/admin/scopes/summary"
                                            className={"dropdown-item py-1 " + (router.pathname == '/admin/scopes/summary' ? ' active' : '')}
                                            aria-current="page">Summary</Link> </li>
                                        <li> <Link
                                            href="/admin/scopes"
                                            className={"dropdown-item py-1 " + (router.pathname == '/admin/scopes' ? ' active' : '')}
                                            aria-current="page">All scopes</Link> </li>
                                        <li> <Link
                                            href="/admin/scopes/new"
                                            className={"dropdown-item py-1 " + (router.pathname == '/admin/scopes/new' ? ' active' : '')}
                                            aria-current="page">Add new scope</Link> </li>
                                    </ul>
                                </div>
                            </li>
                            {/* <li className="mb-1">
                            <button className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (
                                router.pathname.includes('/admin/dictionary') ? 'active' : 'collapsed'
                            )} data-bs-toggle="collapse" data-bs-target="#menu_dict" aria-expanded={
                                router.pathname.includes('/admin/dictionary') ? 'true' : 'false'
                            }>
                                <i className='fa fa-file-text text-indigo-300' />
                                Dictionary
                            </button>
                            <div className={"collapse " + (
                                router.pathname.includes('/admin/dictionary') ? 'show' : ''
                            )} id="menu_dict">
                                <ul className="btn-toggle-nav list-unstyled fw-normal pb-2 small">
                                    <li> <Link href="/admin/dictionary" className={"dropdown-item py-1 " + (router.pathname == '/admin/dictionary' ? ' active' : '')} aria-current="page">Dictionary</Link> </li>
                                    <li> <Link href="/admin/dictionary/new" className={"dropdown-item py-1 " + (router.pathname == '/admin/dictionary/new' ? ' active' : '')} aria-current="page">Add new entry</Link> </li>
                                </ul>
                            </div>
                        </li> 
                        <li className="mb-1">
                            <Link href="/admin/calendar" className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (router.asPath === '/admin/calendar' ? 'active' : '')}>
                                <i className='fa fa-calendar-alt text-indigo-300' />
                                Calendar
                            </Link>
                        </li> */}
                            {userType == 'admin' && <li className="mb-1">
                                <button className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (
                                    (router.pathname.includes('/admin/access/roles') || router.pathname.includes('/admin/access/permissions')) ? 'active' : 'collapsed'
                                )} data-bs-toggle="collapse" data-bs-target="#menu_access_mgt" aria-expanded={
                                    (router.pathname.includes('/admin/access/roles') || router.pathname.includes('/admin/access/permissions')) ? 'true' : 'false'
                                }>
                                    <i className='fa fa-lock text-indigo-300' />
                                    Access control
                                </button>
                                <div className={"collapse " + (
                                    (router.pathname.includes('/admin/access/roles') || router.pathname.includes('/admin/access/permissions')) ? 'show' : ''
                                )} id="menu_access_mgt">
                                    <ul className="btn-toggle-nav list-unstyled fw-normal pb-2 small">
                                        <li> <Link
                                            href="/admin/access/permissions"
                                            className={"dropdown-item py-1 " + (router.pathname == '/admin/access/permissions' ? ' active' : '')}
                                            aria-current="page">Permissions</Link> </li>
                                        {/* <li> <Link legacyBehavior href="/admin/access/permissions/new"><a className={"dropdown-item py-1 " + (router.pathname == '/admin/access/permissions/new' ? ' active' : '')} aria-current="page">Add new permission</a></Link> </li> */}
                                        <li><hr className="dropdown-divider" /></li>
                                        <li> <Link
                                            href="/admin/access/roles"
                                            className={"dropdown-item py-1 " + (router.pathname == '/admin/access/roles' ? ' active' : '')}
                                            aria-current="page">Roles</Link> </li>
                                        <li> <Link
                                            href="/admin/access/roles/new"
                                            className={"dropdown-item py-1 " + (router.pathname == '/admin/access/roles/new' ? ' active' : '')}
                                            aria-current="page">Add new role</Link> </li>
                                    </ul>
                                </div>
                            </li>}

                            {userType == 'admin' && <li className="mb-1">
                                <button className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (
                                    (router.pathname.includes('/admin/notifications')) ? 'active' : 'collapsed'
                                )} data-bs-toggle="collapse" data-bs-target="#menu_notif_mgt" aria-expanded={
                                    (router.pathname.includes('/admin/notifications')) ? 'true' : 'false'
                                }>
                                    <i className='fa fa-bell text-indigo-300' />
                                    Notifications
                                </button>
                                <div className={"collapse " + (
                                    (router.pathname.includes('/admin/notifications')) ? 'show' : ''
                                )} id="menu_notif_mgt">
                                    <ul className="btn-toggle-nav list-unstyled fw-normal pb-2 small">
                                        <li> <Link
                                            href="/admin/notifications/events"
                                            className={"dropdown-item py-1 " + (router.pathname == '/admin/notifications/events' ? ' active' : '')}
                                            aria-current="page">Notification events &amp; triggers</Link> </li>
                                        {/* <li> <Link legacyBehavior href="/admin/notifications/email"><a className={"dropdown-item py-1 " + (router.pathname == '/admin/notifications/email' ? ' active' : '')} aria-current="page">Email settings</a></Link> </li> */}
                                        {/* <li> <Link legacyBehavior href="/admin/notifications/sms"><a className={"dropdown-item py-1 " + (router.pathname == '/admin/notifications/sms' ? ' active' : '')} aria-current="page">SMS settings</a></Link> </li> */}
                                    </ul>
                                </div>
                            </li>}

                            <li className="mb-1">
                                <Link href="/admin/files" className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (router.asPath === '/admin/files' ? 'active' : '')}>

                                    <i className='fa fa-folder text-indigo-300' />File management
                                                                        
                                </Link>
                            </li>

                            <li className="mb-1">
                                <button className={"btn btn-sm py-2 w-100 d-flex btn-toggle align-items-center gap-2 rounded " + (
                                    (router.pathname.includes('/admin/orgunits') || router.pathname.includes('/admin/orgunitlevels')) ? 'active' : 'collapsed'
                                )} data-bs-toggle="collapse" data-bs-target="#menu_org_units" aria-expanded={
                                    (router.pathname.includes('/admin/orgunits') || router.pathname.includes('/admin/orgunitlevels')) ? 'true' : 'false'
                                }>
                                    <i className='fa fa-map text-indigo-300' />
                                    Organization Units
                                </button>
                                <div className={"collapse " + (
                                    (router.pathname.includes('/admin/orgunits') || router.pathname.includes('/admin/orgunitlevels')) ? 'show' : ''
                                )} id="menu_org_units">
                                    <ul className="btn-toggle-nav list-unstyled fw-normal pb-2 small">
                                        <li> <Link
                                            href="/admin/orgunits"
                                            className={"dropdown-item py-1 " + (router.pathname == '/admin/orgunits' ? ' active' : '')}
                                            aria-current="page">Organization Units</Link> </li>
                                        <li><hr className="dropdown-divider" /></li>
                                        {userType == 'admin' && <li> <Link
                                            href="/admin/orgunitlevels"
                                            className={"dropdown-item py-1 " + (router.pathname == '/admin/orgunitlevels' ? ' active' : '')}
                                            aria-current="page">Organization Unit Levels</Link> </li>}
                                    </ul>
                                </div>
                            </li>
                        </> 
                    )}
                </ul>
            </div>
        </nav >
    );
}

export default AdminSidebar